import { Level } from "@/gen/auth/common_pb";
import Component from "@/layouts/layout/component";
import { Loading } from "@/layouts/loading";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/(pharma)/_layout')({
    component: Component,
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
    beforeLoad: async () => {
        const level = localStorage.getItem("level");
        if (level === Level.BRANCH.toString()) {
            return redirect({
                to: "/branch",
            });
        }
    },
});